import { isPhoneNative } from '@helpers';
import { scale } from '@components/frame';
import type { ManageDrawingBottomToolbarResult } from '@v2/components/imageHandling/components/DrawingCanvas/types';

/**
 * Resolves the toolbar's spacing / sizing for the current platform. Phones get a compact
 * variant (smaller hit targets, tighter gaps, shorter dividers) so the rows fit alongside
 * a horizontal ScrollView; desktop / tablet keep the original sizes.
 */
export const useManageDrawingBottomToolbar = (): ManageDrawingBottomToolbarResult => {
  const compact = isPhoneNative;

  const dims = {
    rowGap: scale(compact ? 2 : 4),
    toolMin: scale(compact ? 36 : 44),
    toolPaddingX: scale(compact ? 6 : 10),
    toolPaddingY: scale(compact ? 2 : 4),
    toolBorderRadius: scale(compact ? 7 : 9),
    toolIcon: scale(compact ? 18 : 22),
    undoRedoIcon: scale(compact ? 16 : 20),
    colorContainerMin: scale(compact ? 28 : 36),
    colorCircle: scale(compact ? 22 : 30),
    colorActiveBorder: 2.5,
    colorInactiveBorder: 1.5,
    widthMin: scale(compact ? 36 : 44),
    widthHeight: scale(compact ? 28 : 36),
    widthBorderRadius: scale(compact ? 5 : 7),
    dividerH1: scale(compact ? 24 : 32),
    dividerH2: scale(compact ? 16 : 20),
    dividerMarginH1: scale(compact ? 2 : 4),
    dividerMarginH2: scale(compact ? 2 : 4),
    secondRowPaddingTop: scale(compact ? 8 : 12),
    secondRowPaddingX: scale(compact ? 8 : 12),
    fillPaddingX: scale(compact ? 8 : 10),
    fillPaddingY: scale(compact ? 4 : 6),
    fillBorderRadius: scale(compact ? 5 : 6),
  };

  return { compact, dims };
};
